import { render, staticRenderFns } from "./CarrierListing.vue?vue&type=template&id=582b4548&scoped=true&"
import script from "./CarrierListing.vue?vue&type=script&lang=js&"
export * from "./CarrierListing.vue?vue&type=script&lang=js&"
import style0 from "./CarrierListing.vue?vue&type=style&index=0&id=582b4548&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b4548",
  null
  
)

export default component.exports